import { useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useRecordSuppliersAndBrands(recordType, type = "") {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post(
      "support-extra/dashboard/ListarProveedoresMarcasFicha.php",
      {
        token: userData.token,
        tipoFicha: recordType,
        monturaLente: type,
      }
    );
    setList(response);
  }

  useEffect(() => {
    getData();
  }, [recordType, type]);

  return list;
}
